import { render, staticRenderFns } from "./pm-simple-component-layout.vue?vue&type=template&id=7bc205c4&"
import script from "./pm-simple-component-layout.vue?vue&type=script&lang=js&"
export * from "./pm-simple-component-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports